export default __webpack_public_path__ + "static/media/line-en.e981c3b5.png";